import ReactECharts from "echarts-for-react";

export default function DonutChart({ data }) {
  const options = {
    title: {
      text: "Permit Type wise Chassis Count",
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        name: "Permit Type",
        type: "pie",
        radius: ["40%", "70%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: data, // Use the destructured 'data' prop here
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: 180, width: "100%" }} />
  );
}
